import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_gray_150.png'
import _imports_1 from '@/assets/icons/person_dotted_80.png'


const _withScopeId = n => (_pushScopeId("data-v-6cfab5b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "suggested-parent-icon"
}
const _hoisted_2 = { class: "view-person" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1
}
const _hoisted_5 = { class: "count" }
const _hoisted_6 = { class: "list-unstyled member-list" }

import { computed, inject } from 'vue'
import { PotentialMember } from './FamilyGroupMemberManager'
import { ListPerson } from './FamilyGroupMemberListPerson'
import { ProfileSharingState } from './ProfileSharingState'
import { getMultiSelectState } from '@/util/InputUtil'
import ExpandableItem from '@/util/ExpandableItem.vue'
import FamilyGroupPotentialMember from './FamilyGroupPotentialMember.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupMemberListPerson',
  props: {
    familyGroupId: {},
    listPerson: {},
    allowAdd: { type: Boolean },
    sharingMode: { type: Boolean },
    suggestedParent: { type: Boolean }
  },
  emits: ["memberClick", "memberInvite"],
  setup(__props: any, { emit }) {

const props = __props;





const sharingState = inject<ProfileSharingState>('profileSharingState')!

const hasSharedProfilesRef = computed(() => props.listPerson.potentialMembers.some(isMemberSelected))
const hasMembersRef = computed(() => props.listPerson.potentialMembers.some(pm => pm.member))
const personClassesRef = computed(() => {
  const classes: string[] = []
  if (hasMembersRef.value) {
    classes.push('member')
  }
  else if (hasSharedProfilesRef.value) {
    classes.push('shared')
  }
  return classes
})
const personSelectStateRef = computed(() => getMultiSelectState(props.listPerson.potentialMembers, isMemberSelected))
const canSelectPersonRef = computed(() => props.listPerson.potentialMembers.some(canSelectMember))
const showSuggestedParentRef = computed(() => props.allowAdd && props.sharingMode && props.suggestedParent && 
  !props.listPerson.potentialMembers.some(pm => sharingState.isShared(pm.profileGroupId)))

function isMemberSelected(pm: PotentialMember) {
    return sharingState.isShared(pm.profileGroupId)
}

function canSelectMember(pm: PotentialMember) {
  return pm.isProfileOwner
}

function onPersonCheck() {
  const selectableMembers = props.listPerson.potentialMembers.filter(canSelectMember)
  const oldState = getMultiSelectState(selectableMembers, isMemberSelected)
  sharingState.shareProfiles(selectableMembers.map(pm => pm.profileGroupId!), !oldState) // none/some -> all, all -> none
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["member-list-person", personClassesRef.value])
  }, [
    (showSuggestedParentRef.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
      : _createCommentVNode("", true),
    (_ctx.listPerson.potentialMembers.length != 1)
      ? (_openBlock(), _createBlock(ExpandableItem, {
          key: 1,
          checkbox: _ctx.sharingMode,
          checked: personSelectStateRef.value === true,
          indeterminate: personSelectStateRef.value === undefined,
          checkDisabled: !canSelectPersonRef.value,
          class: "multiple-profiles",
          onCheck: onPersonCheck
        }, {
          item: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (hasSharedProfilesRef.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : (_openBlock(), _createElementBlock("img", _hoisted_4)),
              _createTextVNode(" " + _toDisplayString(_ctx.listPerson.displayName) + " ", 1),
              _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(_ctx.listPerson.potentialMembers.length) + " profiles)", 1)
            ])
          ]),
          content: _withCtx(() => [
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPerson.potentialMembers, (pm) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: pm.id
                }, [
                  _createVNode(FamilyGroupPotentialMember, {
                    pm: pm,
                    "allow-add": _ctx.allowAdd,
                    "sharing-mode": _ctx.sharingMode,
                    onInvite: ($event: any) => (emit('memberInvite', pm)),
                    onClick: ($event: any) => (emit('memberClick', pm))
                  }, null, 8, ["pm", "allow-add", "sharing-mode", "onInvite", "onClick"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["checkbox", "checked", "indeterminate", "checkDisabled"]))
      : (_openBlock(), _createBlock(FamilyGroupPotentialMember, {
          key: 2,
          pm: _ctx.listPerson.potentialMembers[0],
          "allow-add": _ctx.allowAdd,
          "sharing-mode": _ctx.sharingMode,
          onInvite: _cache[0] || (_cache[0] = ($event: any) => (emit('memberInvite', _ctx.listPerson.potentialMembers[0]))),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('memberClick', _ctx.listPerson.potentialMembers[0])))
        }, null, 8, ["pm", "allow-add", "sharing-mode"]))
  ], 2))
}
}

})